import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { DONKEY_OBSERVATIONS } from "./homeData";

// Rotating sceptical Donkey one-liners. Cycles on a timer; static first line under reduced motion.
export function RotatingObservations({ interval = 3800, className = "" }) {
  const reduce = useReducedMotion();
  const [i, setI] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => setI((p) => (p + 1) % DONKEY_OBSERVATIONS.length), interval);
    return () => clearInterval(id);
  }, [interval, reduce]);
  return (
    <div className={`flex items-start gap-3 ${className}`} data-testid="donkey-observations">
      <span className="mt-1.5 w-2 h-2 rounded-full bg-donkey-orange animate-pulse-soft shrink-0" aria-hidden />
      <div className="relative min-h-[2.6rem] flex-1">
        <AnimatePresence mode="wait">
          <motion.p
            key={i}
            initial={reduce ? false : { opacity: 0, y: 12, x: -6, filter: "blur(3px)" }}
            animate={{ opacity: 1, y: 0, x: 0, filter: "blur(0px)" }}
            exit={reduce ? undefined : { opacity: 0, y: -12, filter: "blur(3px)" }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="text-sm sm:text-base italic text-donkey-warm/80 leading-relaxed break-words"
          >
            {DONKEY_OBSERVATIONS[i]}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default RotatingObservations;
